"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    result["default"] = mod;
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
var _a;
Object.defineProperty(exports, "__esModule", { value: true });
var nucleus_1 = require("@lifesize/nucleus");
var redux_1 = require("../utils/redux");
var pairing_1 = require("../constants/pairing");
var remoting = __importStar(require("../constants/remoting"));
var safe_access_1 = __importDefault(require("safe-access"));
var INIT_NUCLEUS = nucleus_1.nucleusConstants.INIT_NUCLEUS, SET_DEVICE_INFO = nucleus_1.nucleusConstants.SET_DEVICE_INFO;
exports.initialState = {
    activePresenter: null,
    activeConnecter: null,
    createDisplayError: null,
    deviceJWT: null,
    devicePin: null,
    displayCipher: null,
    displayPlatform: null,
    isCreatingDevice: false,
    isDisplay: null,
    isUnlinking: false,
    linkingError: null,
    loginError: null,
    pairedUuid: null,
    pairingCode: null,
    pairingError: null,
    presenters: [],
    remoteLinkingCode: null,
    uuid: null
};
var defaultError = 'DEFAULT_ERROR';
exports.default = redux_1.createReducer(exports.initialState, (_a = {},
    _a[pairing_1.actions.CREATE_DISPLAY_DEVICE_REQUEST] = function (state) {
        return __assign(__assign({}, state), { createDisplayError: null, isCreatingDevice: true, loginError: null });
    },
    _a[pairing_1.actions.CREATE_DISPLAY_DEVICE_SUCCESS] = function (state, action) {
        var _a = action.payload, displayCipher = _a.displayCipher, displayPlatform = _a.displayPlatform, uuid = _a.uuid;
        return __assign(__assign({}, state), { displayCipher: displayCipher,
            displayPlatform: displayPlatform, isCreatingDevice: false, pairedUuid: null, uuid: uuid });
    },
    _a[pairing_1.actions.CREATE_DISPLAY_DEVICE_FAILURE] = function (state, action) {
        // set the error to the entire error (object, string, etc. The UI can determine how to best handle it)
        // fall back to a default error string to ensure that the error is truthy
        var error = action.payload.error;
        return __assign(__assign({}, state), { createDisplayError: error || defaultError, isCreatingDevice: false });
    },
    _a[SET_DEVICE_INFO] = function (state, action) {
        return __assign(__assign({}, state), { uuid: safe_access_1.default(action, 'payload.serialNumber'), displayPlatform: safe_access_1.default(action, 'payload.platform') });
    },
    _a[pairing_1.actions.GET_DEVICE_LOGIN_SUCCESS] = function (state, action) {
        var _a = action.payload, deviceJWT = _a.A, deviceClient = _a.CLIENT;
        return __assign(__assign({}, state), { deviceClient: deviceClient,
            deviceJWT: deviceJWT, loginError: null });
    },
    _a[pairing_1.actions.GET_DEVICE_LOGIN_FAILED] = function (state, action) {
        // set the error to the entire error (object, string, etc. The UI can determine how to best handle it)
        // fall back to a default error string to ensure that the error is truthy
        var error = action.payload.error;
        return __assign(__assign({}, state), { loginError: error || defaultError });
    },
    _a[pairing_1.actions.GET_DISPLAY_DEVICE_INFO_SUCCESS] = function (state, action) {
        var _a = action.payload, displayCipher = _a.displayCipher, displayPlatform = _a.displayPlatform, pairedUuid = _a.pairedUuid, presenters = _a.presenters, licenseStatus = _a.licenseStatus;
        return __assign(__assign({}, state), { displayCipher: displayCipher,
            displayPlatform: displayPlatform,
            pairedUuid: pairedUuid,
            presenters: presenters,
            licenseStatus: licenseStatus });
    },
    _a[pairing_1.actions.GENERATE_LINKING_CODE_REQUEST] = function (state) {
        return __assign(__assign({}, state), { linkingError: null });
    },
    _a[pairing_1.actions.GENERATE_LINKING_CODE_SUCCESS] = function (state, action) {
        return __assign(__assign(__assign({}, state), action.payload), { linkingError: null });
    },
    _a[pairing_1.actions.GENERATE_LINKING_CODE_FAILURE] = function (state, action) {
        // set the error to the entire error (object, string, etc. The UI can determine how to best handle it)
        // fall back to a default error string to ensure that the error is truthy
        var error = action.payload.error;
        return __assign(__assign({}, state), { linkingError: error || defaultError });
    },
    _a[pairing_1.subscriptionEventTypes.pairingCodeUpdate] = function (state, action) {
        return __assign(__assign({}, state), { remoteLinkingCode: safe_access_1.default(action, 'payload') });
    },
    _a[pairing_1.actions.REMOTE_UNLINK_BEGIN] = function (state) { return (__assign(__assign({}, state), { isUnlinking: true })); },
    _a[pairing_1.actions.REMOTE_UNLINK_SUCCESS] = function (state) {
        return __assign(__assign({}, state), { linkingError: null, pairedUuid: null, isUnlinking: false });
    },
    _a[pairing_1.actions.REMOTE_UNLINK_FAILED] = function (state, action) {
        return __assign(__assign({}, state), { linkingError: safe_access_1.default(action, 'payload'), isUnlinking: false });
    },
    _a[pairing_1.actions.RESET_PAIRING_STATE] = function (state) {
        // reset the device/display pairing data (preparing for new device/display creation)
        return __assign(__assign({}, state), { activePresenter: null, activeConnecter: null, createDisplayError: null, deviceJWT: null, devicePin: null, displayCipher: null, displayPlatform: null, linkingError: null, loginError: null, pairedUuid: null, presenters: [], remoteLinkingCode: null, uuid: null, isUnlinking: false });
    },
    _a[pairing_1.actions.REMOTE_LINKED] = function (state) {
        // a remote has been successfully linked. clear the linking code (which is immediately invalid)
        return __assign(__assign({}, state), { linkingError: null, remoteLinkingCode: null });
    },
    _a[pairing_1.actions.SET_LINKING_CODE] = function (state, action) {
        return __assign(__assign(__assign({}, state), { linkingError: null }), action.payload);
    },
    _a[remoting.actions.WIRELESS_PRESENTATION_EXCHANGE_PRESENTER] = function (state, action) {
        // triggered when the display receives a new offer with a different sender (from) than the current activePresenter
        return __assign(__assign({}, state), { activePresenter: safe_access_1.default(action, 'payload.newPresenter') });
    },
    _a[remoting.actions.LIFESIZE_CONNECT_EXCHANGE_PRESENTER] = function (state, action) {
        // triggered when the display receives a new offer with a different sender (from) than the current activePresenter
        return __assign(__assign({}, state), { activeConnecter: safe_access_1.default(action, 'payload.newConnecter') });
    },
    _a[pairing_1.actions.DISPLAY_PAIRED] = function (state, action) {
        var pairedUuid = safe_access_1.default(action, 'payload.pairedUuid');
        var pairingCode = safe_access_1.default(action, 'payload.pairCode');
        return __assign(__assign({}, state), { pairedUuid: pairedUuid,
            pairingCode: pairingCode });
    },
    _a[pairing_1.actions.DISPLAY_UNPAIRED] = function () { return exports.initialState; },
    _a[INIT_NUCLEUS] = function (state, action) {
        if (!Object.hasOwnProperty.call(action.payload, 'isDisplay'))
            return state;
        var isDisplay = safe_access_1.default(action, 'payload.isDisplay');
        return __assign(__assign({}, state), { isDisplay: isDisplay });
    },
    _a[pairing_1.actions.SET_LOCAL_PIN] = function (state, action) {
        return __assign(__assign({}, state), { devicePin: safe_access_1.default(action, 'payload') });
    },
    _a));
